import Swiper, { Navigation } from 'swiper';

export function infoSlide(element) {

        const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

      if (!isTouchDevice) {
        // element.addEventListener('touchend', (event) => {
        //     event.preventDefault();
        //     toggleSlide(element);
        // });
         element.addEventListener('mouseenter', (event) => {
            openSlide(element);
        });
        element.addEventListener('mouseleave', (event) => {
            closeSlide(element);
        });
    } 
        // element.addEventListener('mouseenter', (event) => { 
        //     openSlide(element)} );
        // element.addEventListener('mouseleave', (event) => { 
        //     closeSlide(element)} );
        // element.addEventListener('touchend', (event) => { 
        //     toggleSlide(element)} );


        function toggleSlide(el) {
            if (el.dataset.open == "false") {
                openSlide(el);
            } else if (el.dataset.open == "true") {
                closeSlide(el);
            }
        }

        function openSlide(el) {
            el.setAttribute( 'data-open', 'true' );
            var svg =  el.querySelector('[data-slide-svg');
            var description = el.querySelector('.description');
            var up = el.querySelector('.up');
    
            svg.classList.add('hidden');
            description.classList.remove('hidden');
            up.classList.add('open');
            el.classList.add('open');
        }

        function closeSlide(el) {
            el.setAttribute( 'data-open', 'false' );
            var svg =  el.querySelector('[data-slide-svg');
            var description = el.querySelector('.description');
            var up = el.querySelector('.up');
    
            svg.classList.remove('hidden');
            description.classList.add('hidden');
            up.classList.remove('open');
            el.classList.remove('open');
        }
}
